import React from 'react';
export function BeforeAfterSection() {
  return <section className="py-20 bg-brand-card/30" data-id="element-14">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-15">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-center text-white mb-16" data-id="element-16">
          El Contraste de la Activación Folicular
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-17">
          {/* Before Card */}
          <div className="relative rounded-lg overflow-hidden border border-red-900/30 group" data-id="element-18">
            <div className="absolute top-4 left-4 bg-red-900/80 text-white px-3 py-1 text-xs font-bold uppercase rounded z-10 backdrop-blur-sm" data-id="element-19">
              Antes
            </div>
            <img src="https://i.postimg.cc/02SH2Q2c/Caida-de-pelo.webp" alt="Cuero cabelludo debilitado" className="w-full h-80 object-cover filter grayscale contrast-125 transition duration-500 group-hover:scale-105" data-id="element-20" />
            <div className="absolute bottom-0 left-0 w-full p-4 bg-gradient-to-t from-black to-transparent" data-id="element-21">
              <p className="text-gray-300 text-sm font-light" data-id="element-22">
                Folículos asfixiados, raíz debilitada, caída constante al
                cepillar.
              </p>
            </div>
          </div>

          {/* After Card */}
          <div className="relative rounded-lg overflow-hidden border border-brand-gold/50 group shadow-[0_0_30px_rgba(212,175,55,0.1)]" data-id="element-23">
            <div className="absolute top-4 right-4 bg-brand-gold/90 text-black px-3 py-1 text-xs font-bold uppercase rounded z-10 backdrop-blur-sm" data-id="element-24">
              Día 14+
            </div>
            <img src="https://i.postimg.cc/BZwvH21g/Carr4.webp" alt="Cabello abundante y sano" className="w-full h-80 object-cover bg-black transition duration-500 group-hover:scale-105" data-id="element-25" />
            <div className="absolute bottom-0 left-0 w-full p-4 bg-gradient-to-t from-black to-transparent" data-id="element-26">
              <p className="text-brand-gold font-medium text-sm" data-id="element-27">
                Raíces oxigenadas, anclaje profundo, nuevo volumen visible.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}